import { Avatar } from "components/common";
import React from "react";

type UserProfileProps = {
  profileUrl?: string;
  userName?: string;
};
export const UserProfile: React.FC<UserProfileProps> = ({
  profileUrl,
  userName,
}) => <Avatar src={profileUrl} username={userName || "Anonymous"} size="3" />;
